// @flow

import * as numeral from 'numeral';

export default function fmtPercent(value?: number): string {
    const currentFmt = '0.00';
    return `${numeral((value !== undefined && value !== null) ? value : 0.0).format(currentFmt)} %`;
}
